import {
    GlobalNotificationActionsNames,
    GlobalNotificationStatus,
} from "@nova/component-global-notification"
import { IntegrationType } from "@nova/schemas"
import { useIntegrationAuthorizations } from "features/data-management/integrations/useIntegrations"
import { isAuthExpired } from "integrations/oauth/oauthHelpers"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import type { IntegrationAuthorizationResponse } from "@nova/data-facade"
import { useRoutingParameter } from "panels/routing/useRoutingId"
import { selectUserID } from "user/profile/selectors"
import { setGlobalNotificationContext } from "user/profile/slice"

const getId = (auth: IntegrationAuthorizationResponse) => `${auth.id}-${auth.expires}`

const getHasClosed = (auth: IntegrationAuthorizationResponse) => {
    return !!localStorage.getItem(getId(auth))
}

const useExpiredAuthNotification = () => {
    const dispatch = useAppDispatch()
    const routeWorkspaceId = useRoutingParameter("workspaceId") as string
    const userId = useAppSelector(selectUserID)
    const { data: auths } = useIntegrationAuthorizations(
        {
            workspaceId: routeWorkspaceId,
            userId,
            integration: IntegrationType.agol,
        },
        { disabled: !routeWorkspaceId }
    )

    const auth = auths?.at(0)

    if (!auth) return

    const expired = isAuthExpired(auth)

    const hasClosed = getHasClosed(auth)

    if (expired && !hasClosed)
        dispatch(
            setGlobalNotificationContext({
                message: `Your connection to AGOL has expired.`,
                status: GlobalNotificationStatus.default,
                timeoutInMs: 6000,
                timeoutAction: {
                    type: GlobalNotificationActionsNames.AUTH_EXPIRED,
                    context: { id: getId(auth) },
                },
            })
        )

    return
}

export { useExpiredAuthNotification }
